import React from 'react'
import { useTranslation } from 'react-i18next'

interface ILoaderProps {
  showText?: boolean
  color?: string
}
const Loader: React.FC<ILoaderProps> = (props: any) => {
  const { showText = true, color } = props
  // No Suspense: a spinner can mount anywhere, and suspending it would blank the page while the
  // namespace loads. The word shows once it has loaded.
  const { t, ready } = useTranslation('dashboard', { useSuspense: false })
  return (
    <div className={`m-center m-loading ${!showText ? 'no-text' : ''}`} style={{ color: color || '' }}>
      <div className='m-loading-ellipsis'>
        <div style={{ backgroundColor: color || '' }} />
        <div style={{ backgroundColor: color || '' }} />
        <div style={{ backgroundColor: color || '' }} />
        <div style={{ backgroundColor: color || '' }} />
      </div>
      {showText && <span className={'m-loading-text'}>{ready ? t('loader.loading') : ''}</span>}
    </div>
  )
}

export default Loader
